<script lang="ts">
  let { firstName, agentName, status }: { firstName: string; agentName: string; status: string } = $props();
</script>

<section class="today-hero">
  <h1>Hi {firstName}, <span class="today-agent">{agentName}</span> here.</h1>
  <p class="george-status">{status}</p>
</section>

<style>
  .today-hero { margin-bottom: 14px; }
  h1 { font-family: 'Fraunces', Georgia, serif; font-size: 26px; font-weight: 500; letter-spacing: -0.015em; line-height: 1.2; margin-bottom: 8px; color: var(--text); }
  .today-agent { color: var(--accent-ink); font-style: italic; }
  .george-status { font-size: 13.5px; line-height: 1.55; color: var(--text-muted); max-width: 108ch; }
  @media (max-width: 560px) { h1 { font-size: 22px; } }
</style>
